import Color from '@base/features/game/model/color';
import { BehaviorSubject, Subject } from 'rxjs';
import Codes from '@base/features/socket/codes';
import { BaseGameState, Clock, IGameService } from '@base/features/game/model/interfaces';
import { StringColor } from './types';

export class ClockImpl implements Clock {
  clockStatus = new BehaviorSubject(false);
  onClockActivated = new Subject<Color>();
  onMyTimeExpired = new BehaviorSubject(false);
  onClockTick = new BehaviorSubject(0);
  lastUrge = 0;
  seconds = {
    WHITE: 0,
    BLACK: 0,
  };
  activeColor?: Color;
  timer?: NodeJS.Timeout;

  constructor(
    private gameState: BaseGameState,
    private timePerMove: number,
    private gameService: IGameService
  ) {
    this.gameState = gameState;
    this.timePerMove = timePerMove;
    this.gameService = gameService;
    this.seconds = {
      WHITE: timePerMove,
      BLACK: timePerMove,
    };
  }

  setTimePerMove(timePerMove: number) {
    this.timePerMove = timePerMove;
    this.seconds = {
      WHITE: timePerMove,
      BLACK: timePerMove,
    };
  }

  stopClock() {
    if (this.timer) {
      console.debug('Clock stoped');
      this.activeColor = undefined;
      clearInterval(this.timer);
      this.timer = undefined;

      // this.trigger(this.onClockStoped, this);
      this.clockStatus.next(false);
    }
  }

  urgePlayer(color: Color) {
    if (!this.gameState.shouldUrgeOtherPlayer()) {
      return;
    }
    const me = this.gameState.me;
    const table = this.gameState.getTable();
    const now = new Date().getTime();

    if (
      me.isPlayingTable(table) &&
      this.gameState.isGameInProgress() &&
      this.gameState.getMyColor() !== this.activeColor &&
      this.lastUrge + 4000 < now
    ) {
      console.debug('Clock urging opponent...');
      this.gameService.sendPlay(Codes.PlayCommand.CHECK_TIME, me.getPid()!, table.tid);
      this.lastUrge = now;
    }
  }

  startClock(color: Color, restart: boolean) {
    // var scope = this;
    if (this.timer) {
      this.stopClock();
    }

    this.activeColor = color;
    if (this.activeColor) {
      if (restart) {
        this.seconds[color.toString()] = this.timePerMove;
      }
      console.debug('Clock started for ' + color + ' ' + this.seconds[color.toString()]);
      if (this.activeColor) {
        this.timer = setInterval(() => {
          const color = this.activeColor;
          if (!color) throw new Error('No active color provided');
          let prev = this.seconds[color.toString()];

          prev -= 1;
          if (prev < 0) {
            prev = 0;
            this.urgePlayer(color);
          }
          if (prev === 0) {
            // scope.trigger(scope.onMyTimeExpired, scope);
            this.onMyTimeExpired.next(true);
          }
          this.seconds[color.toString()] = prev;
          // scope.trigger(scope.onClockTick, scope);
          this.onClockTick.next(this.seconds[color.toString()]);
        }, 1000);
      }

      this.onClockTick.next(this.seconds[color.toString()]);
      this.onClockActivated.next(this.activeColor);
    }
  }

  setTime(color: StringColor, time: number) {
    console.debug('Clock set time for ' + color + ' to ' + time);
    this.seconds[color] = time;
  }

  getRemainingTime(color: StringColor) {
    return this.seconds[color];
  }

  getElapsedTime(color: Color) {
    return this.timePerMove - this.seconds[color.toString()];
  }

  getActiveColor() {
    return this.activeColor;
  }
}
